<template>
  <v-dialog v-model="dialog" :overlay="false" scrollable max-width="600px">
    <v-card tile flat>
      <v-app-bar flat dark color="primary">
        <v-app-bar-nav-icon><v-icon>far fa-pound-sign</v-icon></v-app-bar-nav-icon>
        <v-toolbar-title>Funds Released</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="closeDialog" dark>
          <v-icon>close</v-icon>
        </v-btn>
      </v-app-bar>
      <v-card flat tile class="ma-0 mb-0">
        <v-card-text>
          <v-form lazy-validation>
            <v-container fluid grid-list-md>
              <v-layout>
                <v-flex xs12>
                  <v-card-text>
                    <v-container grid-list-md class="pa-0">
                      <v-layout>
                        <v-flex sm4>
                          <v-text-field
                            label="Add funds released"
                            v-model="updates.funding_obtained"
                            prefix="£"
                            required
                            :onkeyup="formatCurrency()"
                          >
                          </v-text-field>
                        </v-flex>
                        <v-flex sm4>
                          <v-text-field
                            label="Initial drawdown"
                            v-model="updates.initial_drawdown"
                            prefix="£"
                            required
                            :onkeyup="formatCurrency()"
                          >
                          </v-text-field>
                        </v-flex>
                        <v-flex>
                          <v-menu
                            ref="dateFundingObtainedMenu"
                            :close-on-content-click="false"
                            v-model="obtainedMenu"
                            transition="scale-transition"
                            offset-y
                            full-width
                            :nudge-right="40"
                            min-width="290px"
                            :return-value.sync="updates.dateFundingObtained"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                label="Date released"
                                v-model="updates.dateFundingObtained"
                                prepend-icon="event"
                                readonly
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              @change="$refs.dateFundingObtainedMenu.save(updates.dateFundingObtained)"
                              no-title
                              scrollable
                              v-model="updates.dateFundingObtained"
                            >
                              <v-spacer></v-spacer>
                              <v-btn text color="primary" @click="obtainedMenu = false">Cancel</v-btn>
                            </v-date-picker>
                          </v-menu>
                        </v-flex>
                      </v-layout>
                      <v-layout>
                        <v-flex>
                          <v-text-field
                            label="Monthly interest rate"
                            suffix="%"
                            type="number"
                            v-model="updates.interestRate"
                          >
                          </v-text-field>
                        </v-flex>
                        <v-flex xs12 sm4>
                          <v-select
                            :items="feeTypes"
                            v-model="updates.fee_type"
                            label="Fee type"
                            single-line
                            menu-props="bottom"
                            :loading="isLoading"
                          ></v-select>
                        </v-flex>
                        <v-flex xs12 sm4 v-if="updates.fee_type === 'Percentage'">
                          <v-text-field label="Percentage" v-model="fee_percentage" :loading="isLoading"></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm4 v-if="updates.fee_type === 'Fixed'">
                          <v-text-field
                            label="Expected fee"
                            v-model="updates.expected_fee"
                            :loading="isLoading"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red" :disabled="isSaving" @click.native="closeDialog">Cancel</v-btn>
                    <v-btn
                      color="success"
                      :loading="isSaving"
                      :disabled="fundingObtainedCheck"
                      @click="save('FUNDING RELEASED')"
                    >
                      Update
                    </v-btn>
                  </v-card-actions>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import _ from 'lodash';
import { formatAsCurrency, parseCurrencyString } from '@/utils/formatters';

export default {
  name: 'enquiry-offer-accepted-dialog',
  props: ['show', 'enquiry'],
  data: () => ({
    isLoading: false,
    isSaving: false,
    feeTypes: ['Fixed', 'Percentage'],
    obtainedMenu: false,
    updates: {
      fee_type: 'Fixed',
      fee_percentage: 0,
      expected_fee: 0,
      funding_obtained: null,
      initial_drawdown: null,
      interestRate: 0.0,
      dateFundingObtained: null,
      obtainedMenu: null
    }
  }),
  computed: {
    ...mapGetters(['CalculatedFee', 'EnquiryStatuses']),
    dialog: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit('update:show', value);
      }
    },
    fee_percentage: {
      get() {
        return this.updates.fee_percentage;
      },
      set(value) {
        this.updates.fee_percentage = value;
        let fundingObtained = parseCurrencyString(this.updates.funding_obtained);
        this.updates.expected_fee = (fundingObtained * value) / 100;
      }
    },
    fundingObtainedCheck() {
      return (
        _.isEmpty(this.updates.funding_obtained) ||
        this.updates.funding_obtained < 1 ||
        _.isEmpty(this.updates.dateFundingObtained)
      );
    }
  },
  methods: {
    ...mapActions(['getEnquiryCalculatedFee', 'storeFunderEnquiry', 'addNotification']),
    closeDialog() {
      this.dialog = false;
    },
    save(statusName) {
      this.isSaving = true;

      const enquiryStatus = _.find(this.EnquiryStatuses, ['name', statusName]);
      const updates = {
        enquiry_status_id: enquiryStatus.id,
        funding_obtained: parseCurrencyString(this.updates.funding_obtained),
        initial_drawdown: parseCurrencyString(this.updates.initial_drawdown),
        monthly_interest_rate: this.updates.interestRate,
        date_funding_obtained: this.updates.dateFundingObtained,
        fee_type: this.updates.fee_type,
        fee_percentage: this.updates.fee_percentage,
        expected_fee: this.updates.expected_fee
      };
      this.storeFunderEnquiry({
        id: this.enquiry.id,
        updates
      }).then(() => {
        this.addNotification({ text: 'enquiry updated' });
        this.isSaving = false;
        this.dialog = false;
      });
    },
    formatCurrency() {
      let value = this.updates.funding_obtained;
      const intValue = parseCurrencyString(value);

      this.updates.funding_obtained = formatAsCurrency(intValue);
      this.updates.initial_drawdown = formatAsCurrency(parseCurrencyString(this.updates.initial_drawdown));

      if (this.updates.fee_type === 'Percentage') {
        this.updates.expected_fee = (intValue * this.updates.fee_percentage) / 100;
      }
    }
  },
  watch: {
    dialog(newValue) {
      if (newValue && this.enquiry) {
        this.isLoading = true;
        this.getEnquiryCalculatedFee(this.enquiry);
      }
    },
    CalculatedFee(calculatedFees) {
      this.isLoading = false;
      this.updates.fee_type = calculatedFees.fee_type;
      this.updates.fee_percentage = calculatedFees.fee_percentage;
      this.updates.fixed_fee = calculatedFees.expected_fee;
    },
    'updates.funding_obtained': function(value) {
      this.updates.initial_drawdown = value;
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep {
  div.list__tile,
  .subheader {
    padding: 0 16px 0 0;
  }

  input,
  label {
    font-size: 14px;
  }
}

address {
  font-style: normal;
}
</style>
